import { render, staticRenderFns } from "./OrdenCompraPrecios.vue?vue&type=template&id=422ad08d&"
import script from "./OrdenCompraPrecios.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraPrecios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports